import axios from 'axios'
import util from './store-utils'
import settings from '../settings'
import { STORE_ACTION } from './store'


export const PRODUCT_STORE_COMMIT = {
	VIEW_PRODUCT: "productStore/viewProduct",
	ADD_PRODUCT_ID_TO_PRODUCT_GROUP: "productStore/addProductIdToProductGroup",
	REMOVE_PRODUCT_ID_FROM_PRODUCT_GROUP: "productStore/removeProductIdFromProductGroup",
	UPDATE_PRODUCT_GROUP_LIST: "productStore/updateProductGroupList",
	DELETE_PRODUCT_TEST: "productStore/deleteProductTest"
}

export const PRODUCT_STORE_ACTION = {
	GET_PRODUCT_ROW_LIST: "productStore/getProductRowList",
	GET_PRODUCT_DETAILS: "productStore/getProductDetails",
}


export const PRODUCT_STORE_GETTER = {
PRODUCT_LIST: "productStore/productList",
	PRODUCT_LIST_INDEXED: "productStore/productListIndexed",
	PRODUCT_LIST_LOADING: "productStore/productListLoading",
	PRODUCT_GROUP_LIST: "productStore/productGroupList",
	VIEWED_PRODUCT_ID_LIST: "productStore/viewedProductIdList",
	FAVORITE_PRODUCT_ID_LIST: "productStore/favoriteProductIdList",
	OUTLET_PRODUCT_ID_LIST: "productStore/outletProductIdList",
	PRODUCT_LIST_COMPLETE_DATE: "productStore/productListCompleteData"
}


export default {
	namespaced: true,
	state: {
		data: {
			productList: [], requestCount: 0, productListLoading: false, viewedProductIdList: [], 
			productGroupList: [
				{ key: null, productIdList: [], label: "Alla produkter", sort: 0, icon: null, short: "Alla", searchable: true },
				{ key: "VIEWED", productIdList: [], label: "Nyligen visade", sort: 2, desc: true, icon: 'viewed', short: "Visade", searchable: false },
				{ key: "FAVORITE", productIdList: [], label: "Favoriter", sort: 3, icon: 'favorite', short: "Favoriter", searchable: false },
				

			],
			productListCompleteDate: null


		},
	},
	getters: {

		productList(state) {
			return state.data.productList.filter(item => item != null)
		},
		productListIndexed(state) {
			return state.data.productList;
		},
		productListLoading(state) {
			return state.data.productListLoading;
		},
		productGroupList(state){
			return state.data.productGroupList?.filter(productGroup => productGroup != null)?.sort((a, b) => a.sort - b.sort)
		},
		viewedProductIdList(state){
			return state.data.productGroupList?.find(productGroup => productGroup.key == 'VIEWED')?.productIdList?.filter(productId => productId != null).reverse();
		},
		favoriteProductIdList(state) {
			return state.data.productGroupList?.find(productGroup => productGroup.key == 'FAVORITE')?.productIdList?.filter(productId => productId != null)
		},

		outletProductIdList(state){

			var productIdList = [];

			state.data.productGroupList?.filter(productGroup => productGroup != null)?.forEach(productGroup => {
				if (productGroup.outlet){
					productIdList = productIdList.concat(productGroup.productIdList)
				}
			} )

			productIdList = Array.from(new Set(productIdList)); // FP: Raderar dubbletter


			return productIdList;

		},
		productListCompleteData(state) { // sekunder 
			if (!state.data.productListCompleteDate) {
				return null;
			}

			return state.data.productListCompleteDate
		}

	},
	actions: {


		getProductListAxios({ commit }, { data }) {

			console.log("FP: ", commit);
			console.log("FP: ", data);

			commit("requestStart");
			return axios.get('products'
			).then(result => {

				//	alert("OK");
				if (result && result.data && result.data.status == "OK") {
					// hantera resultet och retuerna det
					//return result
					commit('updateProductList', result.data.productList)
					commit('rebuildSearchModel', null, { root: true });
					alert("getProductListAxios error")
				}

				util.handleResult(result, commit);

				//console.log("FP: result", result);

				return result;
			}).catch(error => {
				util.handleError(error, commit);

			}).finally(() => {
				commit("requestComplete");
			})

		},

		/*getProductRowList({ commit, rootState }, { data }) {
			console.log('FP: commit', commit);
			console.log('FP: data', data);

			const request = util.getGETRequest(this.state.loginToken, data.background);

			commit("requestStart");

			if (this.state.productListLoading){
				console.log('FP: produktListan laddas redan');
				return;
				
			}

			commit("productListLoading", true)

			return fetch(settings.baseUrl + "product-rows", request).then(response => {

				console.log('FP: response: ', response);

				return util.getJson(commit, response, data, rootState.debug).then(json => {

					if (json.status == "OK") {
						commit('updateProductList', json.productList)
						commit('rebuildSearchModel', null, { root: true });
					}

					return json;

				})


			}).catch(() => {

				util.appendEventLogError(commit, "Ett fel har inträffat, försöker igen...", true)

				
				return fetch(settings.baseUrl + "product-rows", request).then(response => {


					return util.getJson(commit, response, data, rootState.debug).then(json => {

						if (json.status == "OK") {
							commit('updateProductList', json.productList)
							commit('rebuildSearchModel', null, { root: true });
						}

						return json;

					})


				}).catch(error => {


					util.appendEventLogError(commit, "Ett fel har inträffat (2), försöker igen...", true)
					console.error("FP: error: ", error);

				})

				
			}).finally(() => {
				commit("productListLoading", false)
				commit("requestComplete");

			})
		},*/

		async getProductRowList({ commit, state, rootState, dispatch }, { data, retries = 5 }) {

			
			if (state.productListLoading){
				return;
			} 

			

			commit("requestStart");
			commit("productListLoading", true);

			let attempt = 0;

			const sleep = ms => new Promise(resolve => setTimeout(resolve, ms));

			try {
				while (attempt < retries) {
					try {
						

						attempt++;

						const request = util.getGETRequest(state.loginToken, data.background, attempt);

						var url = "product-rows"


						const response = await fetch(settings.baseUrl + url, request);

						const silent = true;
						const json = await util.getJson(
							commit,
							response,
							data,
							rootState.debug, 
							silent
						);

						if (json.status === "OK") {
							commit('updateProductList', json.productList);
							commit('setShowStartSpinner', false, { root: true });
							//FP: 2026: CO2: commit('rebuildSearchModel', null, { root: true });

							// flyttade från finally
							commit("productListLoading", false);
							commit("requestComplete");

							await dispatch(	STORE_ACTION.REBUILD_SEARCH_MODEL_ACTION, null, { root: true } ); 
							
							return json; // lyckades
						}

						throw new Error(); 

						
					} catch (error) {

						

						if (rootState.debug){
							const msg = "Fel (" + attempt + "/" + retries + "), försöker igen...";
							util.appendEventLogError( commit, msg, true);
						}
						

						console.error("FP: retry error:", error);

						if (attempt >= retries) {
							throw error; // fångas nedan
						}

						await sleep(2000); // väntar i två sekunder
					}
				}
			} catch (finalError) {
				// Här fångas sista throw error
				util.appendEventLogError(
					commit,
					"Ett fel har inträffat. Kunde inte hämta produktlistan. Försök igen! ",
					true
				);

				console.error("FP: final error after retries:", finalError);

				// flyttade från finally
				commit("productListLoading", false);
				commit("requestComplete");

				// valfritt: bubbla vidare till komponent
				throw finalError;
			} finally {
				//commit("productListLoading", false);
				//commit("requestComplete");
			}
		},
		
		getProductDetails({ commit, rootState }, { data }) {
			console.log('FP: commit', commit);
			console.log('FP: data', data);

			//const request = util.getPOSTRequest(this.state.loginToken, data.background, { name: "fredde" });

			const request = util.getGETRequest(this.state.loginToken, data.background);

			commit("requestStart");

			return fetch(settings.baseUrl + "product/" + data.productId, request).then(response => {

				console.log('FP: response: ', response);

				return util.getJson(commit, response, data, rootState.debug).then(json => {

					if (json.status == "OK") {
						commit('updateProductDetails', { productDetails: json.productDetails, productRow: json.productRow })
						//commit('rebuildSearchModel', null, { root: true });
						//alert("DONE");
					}

					return json;

				})


			}).catch(error => {
				console.error("FP: error: ", error);
				util.appendEventLogError(commit, "Error has occured, check log.", true)
			}).finally(() => {
				commit("requestComplete");

			})
		},



	},
	mutations: {


		resetProductList(state) {
			console.log('FP: updateProductList: data.reset === true');
			state.data.productList = [];
		},


		updateProductList(state, productList) {

			const newProductIdList = new Set(); // skapar set 

			productList.filter(product => product != null).forEach(product => {

				const productId = product.productId
				newProductIdList.add(Number(product.productId)) // adderar till set 
				//const now = new Date().toLocaleString();

				if (state.data.productList[productId] == null) { // om produkten inte finns i listan
					product.meta = util.metaProduct()
					state.data.productList[productId] = product;

				} else {

					const currentProduct = state.data.productList[productId];
					product.meta = currentProduct.meta
					//product.meta.updated = now
					//product.meta = { updated: new Date().toISOString }

					// om befintlig produkt har details och en nya inte har det. 
					const details = currentProduct.details

					if (details && !product.details){
						product.details = details
					}


					state.data.productList[productId] = product
				}

			});

			
			if (productList?.length > 10000){
				state.data.productListCompleteDate = Date.now();

				for (const productId in state.data.productList) {
					if (!newProductIdList.has(Number(productId))) {
						delete state.data.productList[productId];
					}
				}



			}

			//alert(state.data.productList.length)

			//alert("DONE2")

		},

		deleteProductTest(state, productId) {
			delete state.data.productList[productId];
		},

		updateProductDetails(state, data){

			const productDetails = data.productDetails;
			const product = data.productRow;

			const productId = data.productDetails.productId;
			console.log('FP: updateProductDetails: ', data);
			

			if (state.data.productList[productId] == null) { // om produkten inte finns i listan
				product.meta = util.metaProduct()
				product.details = productDetails;
				state.data.productList[productId] = product;
			}else{
				const currentProduct = state.data.productList[productId];
				currentProduct.details = productDetails;
				state.data.productList[productId] = currentProduct
			}

			// addera meta-data-objektet. 
			// TODO patcha objektet. 
		},

		productListLoading(state, productListLoading){
			state.data.productListLoading = productListLoading
		},


		/*viewProduct(state, productId){

			const productIdList = state.data.viewedProductIdList?.filter(currentProductId => productId != currentProductId)


			productIdList.push(parseInt(productId));

			state.data.viewedProductIdList = productIdList
		},*/
		viewProduct(state, productId){

			// return state.data.productGroupList?.find(productGroup => productGroup.key == 'VIEWED')?.productIdList?.filter(productId => productId != null)

			var productGroup = state.data.productGroupList?.find(productGroup => productGroup.key == 'VIEWED');

			var productIdList = productGroup?.productIdList?.filter(currentProductId => productId != currentProductId)

			productIdList.push(parseInt(productId));

			if (!productGroup){
				productGroup = {key: "VIEWED", productIdList: productIdList}
			}else{
				productGroup.productIdList = productIdList
			}

			var productGroupList = state.data.productGroupList?.filter(productGroup => productGroup.key != "VIEWED"  )

			productGroupList.push(productGroup);

			state.data.productGroupList = productGroupList

			console.log('FP: productGroup: ', productGroupList);
			
		},

		addProductIdToProductGroup(state, data) {

			const productId = data.productId
			const key = data.key 

			var productGroup = state.data.productGroupList?.find(productGroup => productGroup.key == key);


			var productIdList = productGroup?.productIdList?.filter(currentProductId => productId != currentProductId)

			productIdList.push(parseInt(productId));

			if (!productGroup) {
				productGroup = { key: key, productIdList: productIdList }
			} else {
				productGroup.productIdList = productIdList
			}

			var productGroupList = state.data.productGroupList?.filter(productGroup => productGroup.key != key)

			productGroupList.push(productGroup);

			state.data.productGroupList = productGroupList

			console.log('FP: productGroup: ', productGroupList);

		},

		removeProductIdFromProductGroup(state, data){

			const productId = data.productId;
			const key = data.key;

			state.data.productGroupList?.map(productGroup => {
				if (productGroup.key == key){

					var productIdList = productGroup?.productIdList?.filter(currentProductId => currentProductId != productId)
					productGroup.productIdList = productIdList

					return productGroup

				}
			});

		},

		updateProductGroupList(state, productGroupList){



			// uppdatera ProductGroupList
			if (productGroupList) {

				productGroupList.forEach(productGroup => {
					const key = productGroup.key;

					// radera om key redan finns 
					state.data.productGroupList = state.data.productGroupList?.filter(productGroup => productGroup.key != key)

					// addera
					state.data.productGroupList.push(productGroup);

				})

			}
			
			
			
		},

	


		requestStart(state) {
			state.data.requestCount++
		},
		requestComplete(state) {

			state.data.requestCount--

			if (state.data.requestCount < 0) {
				state.data.requestCount = 0;
			}
		}


	}
}

